import styled from "styled-components";

export const Container = styled.div`
	padding: 10px;
	height: 100%;
	/* .control-buttons{
		position: fixed;
		left: 0;
		top: 0;
	} */

	.header {
		height: 10%;
		h2 {
			color: #2d7bbc;

			font-size: 2rem;
			font-weight: 700;
		}
	}

	form {
		margin-top: 10px;
		height: 95%;

		.container-inputs {
			height: calc(100% - 100px);
			overflow: auto;
			display: flex;
			padding: 10px;
			padding-bottom: 50px;
			gap: 10px;
			flex-direction: column;
		}

		.control-buttons {
			display: flex;
			width: 100%;
			justify-content: space-between;

			.btn-next {
			}

			.btn-back {
				color: #2d7bbc;
				box-sizing: border-box;
				border: 1px solid #2d7bbc;
			}

			.btn-next:first-of-type {
				margin-left: auto;
			}

			input[type="submit"] {
				border: none;

				cursor: pointer;

				padding: 1rem 3rem;

				border-radius: 0.25rem;

				text-transform: uppercase;

				transition: all 0.3s;

				font-size: 1.25rem;
				font-weight: 700;
			}

			.btn-next,
			input[type="submit"] {
				background: #2d7bbc;
				color: white;
			}

			button,
			input[type="submit"] {
				border: none;
				box-sizing: border-box;
				padding: 1rem 3rem;
				cursor: pointer;
				margin-top: 1rem;

				/* padding: 1rem 3rem; */

				border-radius: 0.25rem;

				text-transform: uppercase;

				transition: all 0.3s;

				font-size: 1.25rem;
				font-weight: 700;
			}
		}

		.dynamic-input-container {
		}
	}
`;
